import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="rewind" maskId="round-filled-radius-1-stroke-1.5-IconRewind"><path d="M17.0743 18.6565L11.7202 14.0712V17.3273C11.7202 18.8221 9.96723 19.6288 8.8319 18.6565L2.61168 13.3295C1.79611 12.631 1.79611 11.3696 2.61168 10.6711L8.8319 5.34412C9.96723 4.37182 11.7202 5.17854 11.7202 6.6733V9.92938L17.0743 5.34412C18.2096 4.37182 19.9626 5.17853 19.9626 6.6733V17.3273C19.9626 18.8221 18.2097 19.6288 17.0743 18.6565Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewind;
